import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const InstagramPage = () => {
  useEffect(() => {
    document.title = 'Instagram｜さかなの木';
    
    // Load Instagram embed script
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="hero-section relative h-[60vh] md:h-[70vh] mt-20">
        <div className="hero-inner relative w-full h-full">
          <img
            className="hero-image absolute inset-0 w-full h-full object-cover object-center"
            src="https://public.readdy.ai/ai/img_res/9d3d605320483702dd4f438f4ff0c8c3.jpg"
            alt="さかなの木 Instagram"
          />
          <div className="hero-overlay absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
          <div className="hero-copy absolute inset-0 flex items-center justify-center text-center text-white px-4">
            <div>
              <div className="w-24 h-24 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6 backdrop-blur-sm">
                <i className="ri-instagram-line text-5xl"></i>
              </div>
              <h1 className="text-4xl md:text-6xl font-bold mb-4">INSTAGRAM</h1>
              <p className="text-lg md:text-xl">毎日更新中！最新情報をチェック</p>
            </div>
          </div>
        </div>
      </section>

      {/* Instagram Feed Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-accent mb-4">
                @sakananoki_unoki
              </h2>
              <p className="text-lg text-gray-600">
                本日のメニューや店内の様子を毎日更新しています
              </p>
            </div>

            {/* Instagram Embed */}
            <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
              <blockquote 
                className="instagram-media" 
                data-instgrm-permalink="https://www.instagram.com/sakananoki_unoki/?utm_source=ig_embed&amp;utm_campaign=loading" 
                data-instgrm-version="14"
                style={{
                  background: '#FFF',
                  border: 0,
                  borderRadius: '3px',
                  boxShadow: '0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)',
                  margin: '1px auto',
                  maxWidth: '540px',
                  minWidth: '326px',
                  padding: 0,
                  width: 'calc(100% - 2px)'
                }}
              >
              </blockquote>
            </div>

            <div className="text-center">
              <a
                href="https://www.instagram.com/sakananoki_unoki/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full text-lg font-medium hover:from-purple-600 hover:to-pink-600 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-instagram-line text-2xl"></i>
                <span>フォローする</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl font-bold text-accent text-center mb-12">
              Instagramで発信している情報
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
                  <i className="ri-restaurant-line text-4xl text-primary"></i>
                </div>
                <h3 className="text-xl font-bold text-accent mb-3">本日のメニュー</h3>
                <p className="text-gray-600">
                  市場から仕入れた新鮮な魚介を使った本日のおすすめメニューを毎日投稿
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
                  <i className="ri-calendar-event-line text-4xl text-primary"></i>
                </div>
                <h3 className="text-xl font-bold text-accent mb-3">イベント情報</h3>
                <p className="text-gray-600">
                  季節の特別メニューや地域イベントへの参加情報をいち早くお届け
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
                  <i className="ri-store-line text-4xl text-primary"></i>
                </div>
                <h3 className="text-xl font-bold text-accent mb-3">店内の様子</h3>
                <p className="text-gray-600">
                  温かみのある店内の雰囲気やスタッフの日常をご紹介
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* LINE CTA */}
      <section className="py-20 bg-[#06C755] text-white">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-3xl mx-auto">
            <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6">
              <i className="ri-line-fill text-4xl"></i>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              公式LINEでも情報発信中
            </h2>
            <p className="text-lg mb-8 text-white/90">
              新メニューやイベント情報をLINEでもお届けしています
            </p>
            <a
              href="https://page.line.me/278ynzvw?oat_content=url&openQrModal=true"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white text-[#06C755] rounded-full text-lg font-medium hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-line-fill text-2xl"></i>
              <span>友だち追加</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default InstagramPage;
